export const ORGANIZATIONS = {
    "sbia":{
        url:"sbia",
        name:"SBIA",
        recipientType:'Organization',
        logo:"https://www.sbia.info/site/wp-content/themes/SBIA2017/imgs/logo_website.png"
    }
};